import * as mockCreators from './mock_creators';

export const recipient1 = mockCreators.createContactMock({
  id: 1,
  typeContact: {
    code: 'quest',
    name: 'Quest',
  },
  phoneNumbers: [
    mockCreators.createPhoneNumberMock({
      contactId: 1,
    }),
  ],
});

export const recipient2 = mockCreators.createContactMock({
  id: 2,
  fullName: 'Frank Evans',
  typeContact: {
    code: 'owner',
    name: 'Owner',
  },
  phoneNumbers: [
    mockCreators.createPhoneNumberMock({
      contactId: 2,
      phoneNumber: '3214321233',
    }),
  ],
});

export const recipients = [recipient1, recipient2];
